import { FindReplace as FindReplaceIcon } from "@mui/icons-material";
import type { TreeItemTemplatePlaceholderFragment } from "../../doc-items/Fragments.generated.js";
import { TemplatePlaceholderSelectTemplateButton } from "../../doc-items/buttons/TemplatePlaceholderSelectTemplateButton.js";

interface Props {
  projectId: string;
  docId: string;
  item: TreeItemTemplatePlaceholderFragment & { id: string };
  disabled: boolean;
  refetchWizardQuestions: () => Promise<unknown>;
  onCompleted?: (itemId: string) => void;
}

export const DataGridTemplatePlaceholderCell = ({
  projectId,
  docId,
  item,
  disabled,
  refetchWizardQuestions,
  onCompleted,
}: Props) => {
  if (!item.placeholderForTemplateType) return null;

  return (
    <TemplatePlaceholderSelectTemplateButton
      projectId={projectId}
      docId={docId}
      itemId={item.id}
      templateTypeName={item.placeholderForTemplateType.templateType.title}
      templateSearchFilterDefaults={item.templateSearchFilterDefaults}
      templateSearchSortingDefaults={item.templateSearchSortingDefaults}
      templateApplicableFor="QUOTE"
      onCompleted={onCompleted}
      type="icon"
      color="primary"
      variant="outlined"
      size="medium"
      Icon={FindReplaceIcon}
      refetchWizardQuestions={refetchWizardQuestions}
      disabled={disabled}
    />
  );
};
